import commonFunc from "../../../common.func";
const mutations = {
    changeEntities(state, val) {
        state.entities = val;
    },
    changeSelectedEntity(state, value) {
        if (localStorage.entitiesWithAttributes) {
            const entitiesWithAttributes = commonFunc.getCompressedItem('entitiesWithAttributes');
            const selectedEntity = entitiesWithAttributes.find((t) => t.id == value);
            state.preparedQueryId = selectedEntity.preparedQueryId;
            state.assigneePreparedQueryId = selectedEntity.assigneePreparedQueryId;
        }
        state.selectedEntity = value;
        localStorage.setItem("selectedEntityId", value);
    },
    toggleIsSideBarVisible(state) {
        if (!state.sidebar.isMoreFilterClicked && state.sidebar.isSideBarVisible) {
            state.sidebar.isSideBarVisible = true;
        } else {
            state.sidebar.isSideBarVisible = !state.sidebar.isSideBarVisible;
        }
        state.sidebar.isMoreFilterClicked = true;
    },
    openSideBar(state) {
        state.sidebar.isSideBarVisible = true;
        state.sidebar.isMoreFilterClicked = false;
    },
    closeSidebar(state) {
        state.sidebar.isSideBarVisible = false;
    },
    destroySideBar(state) {
        state.sidebar.isSideBarVisible = false;
        state.sidebar.properties = {};
        state.sidebar.listeners = {};
        state.sidebar.component = null;
    },
    setSidebarComponent(state, values) {
        state.sidebar.properties = values.properties;
        state.sidebar.listeners = values.on;
        state.sidebar.component = values.component;
        state.sidebar.isActionsEnabled = values.isActionsEnabled ? true : false;
        state.sidebar.actionButtons = state.sidebar.isActionsEnabled ? values.actionButtons : [];
    },
    setSideBarComponentProperty(state, property) {
        state.sidebar.properties[property.key] = property.value;
    },
    setSidebarCloseCallback(state, func) {
        state.sidebar.closeCallback = func
    },
    setHeaderActions(state, actions) {
        state.headerActions = actions;
    },
    setSidebarActionButtons(state, value) {
        state.sidebar.actionButtons = state.sidebar.isActionsEnabled ? value : [];
    },
    clearRouteHistory(state) {
        state.routeHistory = [];
    },
    addRouteToHistory(state, route) {
        state.routeHistory.push(route);
    },
    goToPreviousRoute(state) {
        if (state.routeHistory.length > 1) {
            state.routeHistory.pop();
        }
    },
    setLayoutData(state, keyValues) {
        const keys = Object.keys(keyValues);
        for (const key of keys) {
            state.layoutData[key] = keyValues[key];
        }
    },
    showLoading(state) {
        state.loadingCounter++;
    },
    hideLoading(state) {
        state.loadingCounter--;
        if (state.loadingCounter < 0) {
            state.loadingCounter = 0;
        }
    },
    setLoadedEntityWithAttrs(state) {
        state.isEntitiesWithAttributesLoaded = true;
    }
}

export default mutations;